import {Injectable, Injector} from "@angular/core"
import {EntityModel} from "@fedeltapointofsale/data-client";
import {PriceLevelData} from "./price-level.data";

@Injectable()
export class PriceLevelEntityModel extends EntityModel<PriceLevelData> {

    constructor(injector: Injector) {
        super(injector, PriceLevelData);
    }
}
